import { XemploStateScope } from '@xemplo/types';

export const DS_BASE_URL = 'https://api-dev.xemplo.team';
export const DS_DEFAULT_TIMEOUT = 30000;
export const DS_URL_PREFIX = 'api/v1';
export const DS_V2_URL_PREFIX = 'api/v2';

export const DsAPI = {
  userById: (id?: string | null) => `/users/${id}`,
  personas: '/personas/me',
  companies: '/companies',
  companyById: (id: number) => `/companies/${id}`,
  instances: '/instances',
  instanceById: (id: number) => `/instances/${id}`,
  companiesByInstanceId: (id: number) => `/instances/${id}/companies`,
  navigation: '/nav',
  userflow: (identity?: string) => `userflow/verification/${identity}`,
  embeddedLink: (personaId?: string) => `workato/embedded-link/${personaId}`,
};

export const DSApiUrl = {
  getUserByIdUrl: (baseUrl: string, id?: string | null) =>
    new URL(`${DS_URL_PREFIX}/users/${id}`, baseUrl).toString(),
  getPersonasUrl: (baseUrl: string) =>
    new URL(`${DS_URL_PREFIX}/personas/me`, baseUrl).toString(),
  getCompaniesUrl: (baseUrl: string) =>
    new URL(`${DS_URL_PREFIX}/companies`, baseUrl).toString(),
  getCompaniesV2Url: (baseUrl: string) =>
    new URL(`${DS_V2_URL_PREFIX}/companies`, baseUrl).toString(),
  getServiceProvidersUrl: (baseUrl: string) =>
    new URL(`${DS_V2_URL_PREFIX}/service-providers`, baseUrl).toString(),
  getCompanyByIdUrl: (baseUrl: string, id: number) =>
    new URL(`${DS_URL_PREFIX}/companies/${id}`, baseUrl).toString(),
  getCompaniesByInstanceIdUrl: (baseUrl: string, id: number) =>
    new URL(`${DS_URL_PREFIX}/instances/${id}/companies`, baseUrl).toString(),
  getInstancesUrl: (baseUrl: string) =>
    new URL(`${DS_URL_PREFIX}/instances`, baseUrl).toString(),
  getInstanceByIdUrl: (baseUrl: string, id: number) =>
    new URL(`${DS_URL_PREFIX}/instances/${id}`, baseUrl).toString(),
  getNavigationUrl: (baseUrl: string) =>
    new URL(`${DS_V2_URL_PREFIX}/nav`, baseUrl).toString(),
  getUserflowUrl: (baseUrl: string, identity?: string) =>
    new URL(`${DS_URL_PREFIX}/userflow/verification/${identity}`, baseUrl).toString(),
  confirmPersonaTransfer: (baseUrl: string, transferId?: string) =>
    new URL(
      `${DS_URL_PREFIX}/persona-transfers/${transferId}/confirmation`,
      baseUrl,
    ).toString(),
  postTransferPersonas: (baseUrl: string) =>
    new URL(`${DS_URL_PREFIX}/persona-transfers`, baseUrl).toString(),
  getCurrentUserTransferPersonas: (baseUrl: string) =>
    new URL(`${DS_URL_PREFIX}/persona-transfers/me`, baseUrl).toString(),
  getConnectEmbeddedUrl: (baseUrl: string, personaId?: string) =>
    new URL(`${DS_V2_URL_PREFIX}/workato/embedded-link/${personaId}`, baseUrl).toString(),
  patchXemploStateUrl: (baseUrl: string, scope: XemploStateScope) =>
    new URL(`${DS_V2_URL_PREFIX}/state/${scope}`, baseUrl).toString(),
};
